// src/components/common/ConsoleOverviewCards.tsx

import { Box } from "@mui/material";
import clsx from "clsx";
import { useAppStore } from "../../../../hooks/useStores";
import OverviewCard from "./Card/OverviewCard";
import styles from "./ConsoleOverviewCards.module.scss";
export type OverviewCardType = {
	icon: string;
	title: string;
	description: string;
	link: string;
	newTab?: boolean;
	onClick?: React.MouseEventHandler<HTMLAnchorElement>;
	loading?: boolean;
};

interface Props {
	cards: OverviewCardType[];
}

const ConsoleOverviewCards = ({ cards }: Props) => {
	const { uiStore } = useAppStore();
	return (
		<Box
			className={clsx(styles.container, {
				[styles.cards]: true,
				[styles.customStyle]: uiStore.shouldDisplayCustomerViewBanner(),
			})}
		>
			{cards.map(({ icon, title, description, link, newTab, onClick, loading }, index) => (
				<OverviewCard
					key={index}
					icon={icon}
					title={title}
					description={description}
					link={link}
					newTab={newTab}
					onClick={onClick}
					loading={loading}
				/>
			))}
		</Box>
	);
};

export default ConsoleOverviewCards;
